import request from '@/utils/request'

/**
 * @apiName 维保订单列表
 */
export function getOrderList(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/order/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 门店列表
 */
export function getPurchaseStoreList(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/store/list',
    method: 'POST',
    data,
  })
}
